module.exports = [{
      plugin: require('C:/development/sodaden/pacha-website/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1170,"quality":90,"linkImagesToOriginal":false},
    },{
      plugin: require('C:/development/sodaden/pacha-website/node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://rootsofpacha.com"},
    },{
      plugin: require('C:/development/sodaden/pacha-website/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-153240895-1","head":true,"anonymize":true,"respectDNT":true,"exclude":["/preview/**"],"sampleRate":100,"siteSpeedSampleRate":10},
    }]
